import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Config } from '@styles/icons/config.svg';
import React from 'react';

export const ConfigIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Config} viewBox={'0 0 17 17'} />
);

export default ConfigIcon;
